$(document).ready(function() {
      if (/Mobi|Android/i.test(navigator.userAgent)) {
          
          $('body').on('click','.shop-the-look__hot-spot', function() {
               $('.shop-the-look__hot-spot').not($(this)).attr('clicked', 0);
            var clicked = parseInt($(this).attr('clicked'));
             clicked ++;
             $(this).attr('clicked', clicked);
            if(clicked >= 2) {
              var target = $(this).attr('target');
              var tooltip = $(this).closest('.multi-column__item').find(target);
              
              if (tooltip.length > 0 && tooltip.find('a').length > 0) {
                // $(this).attr('redirect-to', tooltip.find('a').attr('href'));
                window.location.href = tooltip.find('a').attr('href');
              }
            }
          });
      } else {
          
        $('body').on('click','.shop-the-look__hot-spot', function() {
      
            var target = $(this).attr('target');
            var tooltip = $(this).closest('.multi-column__item').find(target);
            
            if (tooltip.length > 0 && tooltip.find('a').length > 0) {
              // $(this).attr('redirect-to', tooltip.find('a').attr('href'));
              window.location.href = tooltip.find('a').attr('href');
            }
          });
      }
});
$(function () {
  $(document).ready(function() {
            var defaultContent = '.content_product_1';

           $('.shop-the-look__hot-spot').hover(function() {
              var target = $(this).attr('target');
              var parent = $(this).closest('.multi-column__item');
               var targetEl = parent.find(target);
              parent.find('.shop-the-look__item-product').removeClass('active');
              parent.find(target).addClass('active');
              
              var tooltipWidth = parent.find(target).outerWidth();
              var tooltipHeight = parent.find(target).outerHeight();
              var parentWidth = parent.outerWidth();
              var parentHeight = parent.outerHeight();
              var btnOffset = $(this).position();
              var btnHeight = $(this).outerHeight();
              var btnWidth = $(this).outerWidth();
              
              var margin = 15;
              var top = btnOffset.top + btnHeight + margin;
              var left = btnOffset.left;
          
              if (top + tooltipHeight > parentHeight || top < 0) {
                  top = btnOffset.top - tooltipHeight - margin;
                console.log(1);
              }
              
              if (left + tooltipWidth > parentWidth) {
                  left = btnOffset.left - tooltipWidth + btnWidth - margin;
                console.log(2);
              }
              
              targetEl.css({
                  top: top + 'px',
                  left: left + 'px'
              });
              
          }, function() {
              if (!$(this).closest('.multi-column__item').find('.shop-the-look__item-product:hover').length) {
                  $(this).closest('.multi-column__item').find('.shop-the-look__item-product').removeClass('active');
                  $(this).closest('.multi-column__item').find(defaultContent).addClass('active');
              }
          });

          $('.shop-the-look__item-product').hover(function() {
              $(this).addClass('active');
          }, function() {
              $(this).removeClass('active');
             $(this).closest('.multi-column__item').find(defaultContent).addClass('active');
          });
      });        

});
  document.addEventListener('DOMContentLoaded', function() {
   $('.btn_hover_1').each(function() {
         var target = $(this).attr('target');
          var parent = $(this).closest('.multi-column__item');
          
          parent.find('.shop-the-look__item-product').removeClass('active');
         var targetEl = parent.find(target);
         if (targetEl.length > 0) {
          targetEl.addClass('active');
          
          var tooltipWidth = targetEl.outerWidth();
          var tooltipHeight = targetEl.outerHeight();
          var parentWidth = parent.outerWidth() ;
          var parentHeight = parent.outerHeight();
          var btnOffset = $(this).position();
          var btnHeight = $(this).outerHeight();
          var btnWidth = $(this).outerWidth();
          
          var margin = 15;
          var top = btnOffset.top + btnHeight + margin;
          var left = btnOffset.left;
      
          if (top + tooltipHeight > parentHeight || top < 0) {
              top = btnOffset.top - tooltipHeight - (margin/2);
          }
          
          if (left + tooltipWidth > parentWidth) {
              left = btnOffset.left - tooltipWidth + btnWidth - (margin/2);
          }
          
          targetEl.css({
              top: top + 'px',
              left: left + 'px'
          });
          }
      });
});